import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Flyout } from '@els/els-react--flyout';
import { Icon } from '@els/els-react--icon';
import { getCleanFromTags } from '@Containers/PatentFamilyClustering/utils';
import PatentContentContext from './PatentContentContext';

export const manuallyCuratedFlyoutText =
  'This patent has been manually curated. Manually curated patents are shown on top of the patent family.';

function ProcessingModeWrapper({ children }) {
  const { document } = useContext(PatentContentContext);
  const { id, processingMode } = document;
  const shouldDisplayProcessingMode = getCleanFromTags(processingMode) === 'manual';

  return (
    <div className="patent-content__flex-row">
      {children}
      {shouldDisplayProcessingMode && (
        <div className="patent-content__processing-mode e2e-processing-mode">
          <span>Manually curated</span>
          <Flyout
            className="patent-content__processing-mode-flyout"
            flyout={manuallyCuratedFlyoutText}
            shouldCloseOnESC
            placement="bottom-start"
            pointerType="primary">
            <button className="button button--link u-els-anchorize c-els-link c-els-link--with-icon c-els-anchorized-button" type="button">
              <Icon
                id={id}
                sprite="InformationOutlineCircle"
                size="xs"
                a11y={{ name: 'Manually curated', description: 'Manually curated patent' }}
              />
            </button>
          </Flyout>
        </div>
      )}
    </div>
  );
}

ProcessingModeWrapper.propTypes = {
  children: PropTypes.node,
};

export default ProcessingModeWrapper;
